import {getManagerHeader} from "../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../assets/Constants";
import {base64DecodeUnicode} from "../../assets/functions";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPencil, faTrash} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";
import {Accordion} from "react-bootstrap";

export const getAllProductCategories = async () => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'productCategories', {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
};
export const getProductCategoryById = async (id) => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + `productCategories/${id}`, {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
};

export const getAllProductCategoriesObject = async () => {
    const allProductCategories = await getAllProductCategories();
    const allProductCategoriesObject = allProductCategories.map((productCategory, index) => {
        return {
            id: productCategory.id,
            value: productCategory.id,
            label: productCategory.category.persianName,
            parentId: productCategory.parentId,
        }
    })
    return allProductCategoriesObject;
}

export const printProductCategoryAccordion = (productCategory) => {
    return (
        <Accordion.Item key={productCategory.id} eventKey={productCategory.id}>
            <Accordion.Header className={`${productCategory.children.length == 0 ? "not-expandable" : ""} `}>
                {productCategory.label}
                <div className="buttons d-flex me-auto">
                    <Link to={`update/${productCategory.id}`} className={"btn d-flex align-items-center"}>
                        <FontAwesomeIcon width={25} icon={faPencil}/>
                    </Link>

                    <button className={"btn d-flex align-items-center"}><FontAwesomeIcon width={25} icon={faTrash}/>
                    </button>
                </div>
            </Accordion.Header>
            {productCategory.children.length > 0 && <Accordion.Body>
                {
                    productCategory.children.map((p, index) => {
                        return (
                            printProductCategoryAccordion(p)
                        );
                    })
                }
            </Accordion.Body>
            }
        </Accordion.Item>
    );
}



